<template>
    <div>
        <Button
            @click="show = true"
            color="danger-outline"
            size="small"
            iconName="trash"
            class="w-full"
        >
            Delete
        </Button>

        <ModalConfirmation
            :show="show"
            :action="submit"
            color="danger"
            title="Are you sure you want to delete this Automation?"
            actionText="Yes, delete"
            :actionProcessing="apiFormRef?.loading.valueOf()"
            @close="show = false"
        >
            <template #content>
                <div class="text-gray-500 text-center">
                    This action is irreversible.
                </div>
            </template>
        </ModalConfirmation>

        <ApiForm
            :url="urlFactory.makeAutomationDeleteUrl(automation.id)"
            method="POST"
            :disableCatch="false"
            ref="apiFormRef"
        />
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import ModalConfirmation from '@/Shared/Component/ModalConfirmation.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Automation from '@/App/Automation/Entity/Automation'

    const emits = defineEmits(['onSuccess'])

    const props = defineProps({
        automation: {
            type: Object as PropType<Automation>,
            required: true,
        },
    })

    const show = ref(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then(() => {
                emits('onSuccess')
                show.value = false
            })
            ?.catch(() => {
                show.value = false
            })
    }
    const urlFactory = new UrlFactory()
</script>
